import React, { Component } from 'react';
import logo from './zertifikat-siegel.png';

class App extends Component {
  appStyles() {
    return {
      boxSizing: 'border-box',
      backgroundColor: 'white',
      color: '#111',
      width: (this.props.orientation === 'portrait') ? '140px' : '290px',
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
      textTransform: 'none',
      textShadow: 'none',
      border: '1px solid lightGray',
      overflow: 'hidden',
      textAlign: (this.props.orientation === 'portrait') ? 'center' : 'left',
      fontStyle: 'normal',
      lineHeight: '1.1'
    }
  }

  textStyles() {
    return {
      fontFamily: 'Arial, sans-serif',
      verticalAlign: 'top',
      width: (this.props.orientation !== 'portrait') && '145px',
      padding: (this.props.orientation === 'portrait') && '0 8px',
      display: 'inline-block'
    }
  }

  imageStyles() {
    return {
      display: 'block',
      marginRight: (this.props.orientation !== 'portrait') && '3px'
    }
  }

  imageLinkStyles() {
    return {
      display: 'inline-block'
    }
  }

  linkStyles() {
    return {
      color: '#128dc4',
      textDecoration: 'none',
      fontStyle: 'normal'
    }
  }

  headlineStyles() {
    return {
      color: '#128dc4',
      fontFamily: 'Arial, sans-serif',
      marginBottom: '5px',
      fontWeight: 'bold',
      textTransform: 'none',
      fontSize: (this.props.orientation === 'portrait') ? '18px' : '20px',
      marginTop: (this.props.orientation === 'portrait') ? '0' : '12px'
    }
  }

  subheadlineStyles() {
    return {
      color: '#777',
      textTransform: 'none',
      fontFamily: 'Arial, sans-serif',
      display: 'inline-block',
      fontWeight: 'normal',
      fontSize: (this.props.orientation === 'portrait') ? '13px' : '15px'
    }
  }

  paragraphStyles() {
    return {
      fontFamily: 'Arial, sans-serif',
      marginTop: '1em',
      marginBottom: '1em'
    }
  }

  // displays the latest 3 awards years as a sentence
  awardsText() {
    // NOTE: we slice here before reversing to create a copy of
    // the awards array. otherwise we change the passed in data
    // in-place (i.e.: the portrait variant would again reverse the array!)
    const awards = this.props.awards.slice(0).map((a) => a.year).sort().reverse().slice(0, 3)
    const prefix = (awards.length > 1) ? 'in den Jahren' : 'im Jahr'
      return (
        <span>
        {prefix} {this.awardYears(awards)}
        </span>
      )
  }

  awardYears(years) {
    return (
      <span>
        {years.map((a, i) => {
           return(
             <span key={a}>{i > 0 && ((i+1) < years.length ? ', ' : ' und ')}
               <strong>{a}</strong>
             </span>
           )
        })}
      </span>

    )
  }

  organisationUrl() {
    return 'https://www.schueleraustausch.de/organisations/' + this.props.slug
  }

  // could be null or undefined if awards is empty
  latestAwardYear() {
    const years = this.props.awards.map((a) => a.year)
    return years.pop()
  }

  // always returns a valid url (in case of missing award year links to latest global awards page)
  latestAwardsUrl() {
    return 'https://www.schueleraustausch.de/awards/feedback/' + (this.latestAwardYear() || '')
  }

  render() {
    return (
      <div style={this.appStyles()}>
        <a href={this.latestAwardsUrl()} style={this.imageLinkStyles()} target='_blank'>
          <img src={logo} style={this.imageStyles()} alt='schueleraustausch-zertifikat-logo' />
        </a>
        <div style={this.textStyles()}>
        <h2 style={this.headlineStyles()}>Zertifikat<br/>
          <small style={this.subheadlineStyles()}>
            für exzellentes Teilnehmerfeedback
          </small>
        </h2>
        <p style={this.paragraphStyles()}>
          für&nbsp;
          <a href={this.organisationUrl()}
             style={this.linkStyles()} target='_blank'>{this.props.name}</a>&nbsp;
          {this.awardsText()}
        </p>
        </div>
      </div>
    );
  }
}

export default App;
